import { AssetsUserDetailsServiceBase } from './assets-user-details.service.base';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ENVIRONMENT, UserDetailsWithAttributes, UserDetailsWithAttributesService, UserTypeInfoStorage } from '@scisys-uim/uim-common';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class AssetsUserDetailsService extends AssetsUserDetailsServiceBase {
  constructor(protected http: HttpClient,
    protected userDetailsTypeInfoStorage: UserTypeInfoStorage,
    protected userDetailsService: UserDetailsWithAttributesService,
    @Inject(ENVIRONMENT) protected environment: any) {
    super(http, environment);
    this.userDetailsTypeInfoStorage.nextNonNullItem().subscribe();
  }

  getUserDetailsIdentifyingTypes(): string[] {
    return ['eAssetsUser'];
  }

  getUserDetailsExcludedByExistingUserDetailsTypes(element: UserDetailsWithAttributes): string[] {
    const ownTypes = this.getUserDetailsIdentifyingTypes() || [];
    const userTypeInfos = this.userDetailsTypeInfoStorage.get();
    var conflictingTypes = userTypeInfos?.getUserTypesExcludedFromForUser(element) || [];
    conflictingTypes = conflictingTypes.filter((el) => ownTypes.includes(el));
    return conflictingTypes;
  }

  isUserDetailsExcludedByExistingUserDetailsType(element: UserDetailsWithAttributes): boolean {
    return this.getUserDetailsExcludedByExistingUserDetailsTypes(element).length > 0;
  }

  findUserDetailsWithAttributesByUsername(username: string): Observable<UserDetailsWithAttributes> {
    return this.userDetailsService.get(username);
  }
}



